/**
 * Crea la disposición del tragamonedas
 * @param {*} scene
 */
export function crearValoresTragamonedas(scene) {
  //Fila 1
  scene.posicion1 = scene.add.image(184, 84, "valor3Estatico");
  scene.posicion1.setDepth(100);
  scene.valorPosicion1 = 3;
  scene.posicion2 = scene.add.image(280, 84, "valor5Estatico");
  scene.posicion2.setDepth(100);
  scene.valorPosicion2 = 5;
  scene.posicion3 = scene.add.image(375, 84, "valor7Estatico");
  scene.posicion3.setDepth(100);
  scene.valorPosicion3 = 7;
  scene.posicion4 = scene.add.image(471, 84, "valor9Estatico");
  scene.posicion4.setDepth(100);
  scene.valorPosicion4 = 9;
  scene.posicion5 = scene.add.image(567, 84, "valor11Estatico");
  scene.posicion5.setDepth(100);
  scene.valorPosicion5 = 11;

  //Fila 2
  scene.posicion6 = scene.add.image(184, 144, "valor2Estatico");
  scene.posicion6.setDepth(100);
  scene.valorPosicion6 = 2;
  scene.posicion7 = scene.add.image(280, 144, "valor4Estatico");
  scene.posicion7.setDepth(100);
  scene.valorPosicion7 = 4;
  scene.posicion8 = scene.add.image(375, 144, "valor6Estatico");
  scene.posicion8.setDepth(100);
  scene.valorPosicion8 = 6;
  scene.posicion9 = scene.add.image(471, 144, "valor8Estatico");
  scene.posicion9.setDepth(100);
  scene.valorPosicion9 = 8;
  scene.posicion10 = scene.add.image(567, 144, "valor10Estatico");
  scene.posicion10.setDepth(100);
  scene.valorPosicion10 = 10;

  //Fila 3
  scene.posicion11 = scene.add.image(184, 204, "valor1Estatico");
  scene.posicion11.setDepth(100);
  scene.valorPosicion11 = 1;
  scene.posicion12 = scene.add.image(280, 204, "valor1Estatico");
  scene.posicion12.setDepth(100);
  scene.valorPosicion12 = 1;
  scene.posicion13 = scene.add.image(375, 204, "valor1Estatico");
  scene.posicion13.setDepth(100);
  scene.valorPosicion13 = 1;
  scene.posicion14 = scene.add.image(471, 204, "valor1Estatico");
  scene.posicion14.setDepth(100);
  scene.valorPosicion14 = 1;
  scene.posicion15 = scene.add.image(567, 204, "valor1Estatico");
  scene.posicion15.setDepth(100);
  scene.valorPosicion15 = 1;

  //Fila 4
  scene.posicion16 = scene.add.image(184, 264, "valor3Estatico");
  scene.posicion16.setDepth(100);
  scene.valorPosicion16 = 3;
  scene.posicion17 = scene.add.image(280, 264, "valor5Estatico");
  scene.posicion17.setDepth(100);
  scene.valorPosicion17 = 5;
  scene.posicion18 = scene.add.image(375, 264, "valor7Estatico");
  scene.posicion18.setDepth(100);
  scene.valorPosicion18 = 7;
  scene.posicion19 = scene.add.image(471, 264, "valor9Estatico");
  scene.posicion19.setDepth(100);
  scene.valorPosicion19 = 9;
  scene.posicion20 = scene.add.image(567, 264, "valor11Estatico");
  scene.posicion20.setDepth(100);
  scene.valorPosicion20 = 11;

  scene.anims.create({
    key: "valor1movimiento",
    frames: scene.anims.generateFrameNumbers("valor1Animado", {
      start: 0,
      end: 14,
    }),
    frameRate: 10,
    repeat: -1,
  });

  scene.anims.create({
    key: "valor2movimiento",
    frames: scene.anims.generateFrameNumbers("valor2Animado", {
      start: 0,
      end: 14,
    }),
    frameRate: 10,
    repeat: -1,
  });

  scene.anims.create({
    key: "valor3movimiento",
    frames: scene.anims.generateFrameNumbers("valor3Animado", {
      start: 0,
      end: 14,
    }),
    frameRate: 10,
    repeat: -1,
  });

  scene.anims.create({
    key: "valor4movimiento",
    frames: scene.anims.generateFrameNumbers("valor4Animado", {
      start: 0,
      end: 14,
    }),
    frameRate: 10,
    repeat: -1,
  });

  scene.anims.create({
    key: "valor5movimiento",
    frames: scene.anims.generateFrameNumbers("valor5Animado", {
      start: 0,
      end: 14,
    }),
    frameRate: 10,
    repeat: -1,
  });

  scene.anims.create({
    key: "valor6movimiento",
    frames: scene.anims.generateFrameNumbers("valor6Animado", {
      start: 0,
      end: 14,
    }),
    frameRate: 10,
    repeat: -1,
  });

  scene.anims.create({
    key: "valor7movimiento",
    frames: scene.anims.generateFrameNumbers("valor7Animado", {
      start: 0,
      end: 14,
    }),
    frameRate: 10,
    repeat: -1,
  });

  scene.anims.create({
    key: "valor8movimiento",
    frames: scene.anims.generateFrameNumbers("valor8Animado", {
      start: 0,
      end: 14,
    }),
    frameRate: 10,
    repeat: -1,
  });

  scene.anims.create({
    key: "valor9movimiento",
    frames: scene.anims.generateFrameNumbers("valor9Animado", {
      start: 0,
      end: 14,
    }),
    frameRate: 10,
    repeat: -1,
  });

  scene.anims.create({
    key: "valor10movimiento",
    frames: scene.anims.generateFrameNumbers("valor10Animado", {
      start: 0,
      end: 14,
    }),
    frameRate: 10,
    repeat: -1,
  });

  scene.anims.create({
    key: "valor11movimiento",
    frames: scene.anims.generateFrameNumbers("valor11Animado", {
      start: 0,
      end: 14,
    }),
    frameRate: 10,
    repeat: -1,
  });
  
}
